import { Load } from "@goodfill/load";
import {
  BusinessesAndOccupation,
  listBusinessesAndOccupations,
} from "../../backendApi/lambdas/individualApplication/listBusinessesAndOccupations";
import { CognitoIdToken } from "@goodfill/backend-api-client";
import { Button, Icon, Span, Spinner } from "@goodfill/ui-components";
import { FocusEventHandler, forwardRef, Ref, useCallback } from "react";
import { Select } from "@goodfill/blueprint-select";

const itemToStringForSelected = (businessesAndOccupation: BusinessesAndOccupation) =>
  businessesAndOccupation.occupation;
const itemToStringForList = (businessesAndOccupation: BusinessesAndOccupation) =>
  `${businessesAndOccupation.business} - ${businessesAndOccupation.occupation}`;
const itemToStringId = (businessesAndOccupation: BusinessesAndOccupation) =>
  `${businessesAndOccupation.business} - ${businessesAndOccupation.occupation}`;

interface BusinessAndOccupationSelectProps {
  cognitoIdToken: CognitoIdToken;
  selected: BusinessesAndOccupation | null;
  onSelect: (account: BusinessesAndOccupation | null) => void;
  placeholder?: string;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  ref?: Ref<HTMLButtonElement>;
  id?: string;
  disabled?: boolean;
}

export const BusinessAndOccupationSelect = forwardRef<HTMLButtonElement, BusinessAndOccupationSelectProps>(
  ({ cognitoIdToken, selected, onSelect, placeholder, onBlur, id, disabled }, ref) => {
    const load = useCallback(() => listBusinessesAndOccupations(cognitoIdToken), [cognitoIdToken]);

    return (
      <Load load={load}>
        {(businessesAndOccupations, isLoading, _error) => {
          if (isLoading) {
            return <Spinner />;
          }

          return (
            <Select<BusinessesAndOccupation>
              placeholder={placeholder ?? ""}
              items={businessesAndOccupations ?? []}
              selected={selected}
              onSelect={onSelect}
              itemToStringId={itemToStringId}
              itemToStringForList={itemToStringForList}
              itemToStringForSelected={itemToStringForSelected}
              onBlur={onBlur}
              disabled={disabled}
              popoverProps={{
                matchTargetWidth: true,
              }}
            >
              <Button
                fill
                ref={ref}
                id={id}
                className="justify-between rounded-[6px] pl-0 shadow-none border border-color-gray"
              >
                <Span>{selected ? itemToStringForSelected(selected) : placeholder}</Span>
                <Icon name="caret-down" />
              </Button>
            </Select>
          );
        }}
      </Load>
    );
  },
);
